import { render } from "./Music.vue?vue&type=template&id=0c2b3b9a&scoped=true"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"

import "./Music.vue?vue&type=style&index=0&id=0c2b3b9a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2b3b9a"]])

export default __exports__